import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/consumableType/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/consumableType/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/consumableType/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/consumableType/save', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/consumableType/update', params,options);

export const treeChildren = (params, options) =>
  request.get('/api/v4ward/consumableType/treeChildren', Object.assign({}, options, { params }));

export const tree = (params, options) =>
  request.get('/api/v4ward/consumableType/tree', Object.assign({}, options, { params }));
